module.exports = __webpack_public_path__ + "img/logo_blanco_nunoa.1022c871.png";